module.exports = __webpack_public_path__ + "media/images/new_landing/case/case-johany-2-d3672199dd06a604fd7b0e6b77537be6.png";